import type { RouteRecordRaw } from 'vue-router'

export const privacyPolicyRouteName = 'privacyPolicy'
export const privacyPolicyBaseRouteName = 'privacyPolicy.base'

export const getPrivacyPolicyRoutes = (): RouteRecordRaw[] => [
  {
    name: privacyPolicyBaseRouteName,
    path: 'privacy-policy',
    component: () => import('@/components/containers/SinglePageContainer.vue'),
    props: {
      isPrivacyPolicyPage: true,
    },
    children: [
      {
        name: privacyPolicyRouteName,
        path: '',
        component: () => import('@/components/views/PrivacyPolicy.vue'),
        meta: {
          accessControlGroups: ['PrivacyPolicyStrategy'],
        },
      },
    ],
  },
]
